import Vue from 'vue'
import axios from '@/helpers/axiosInterceptors'
import VueAxios from 'vue-axios'

const baseURL = process.env.VUE_APP_URL_API

axios.defaults.baseURL = baseURL
axios.defaults.headers = {'Accept': 'application/json'}

Vue.use(VueAxios, axios)